export default [
  'london',
  'manchester',
  'brighton',
]
